import React, { ReactElement } from 'react';
import { useSafeArea } from 'react-native-safe-area-context';

import { CloseButton } from 'components/PopupModal/components/CloseButton';

type Props = { onPress: () => void };

export const NHSCloseButton = ({ onPress }: Props): ReactElement => {
  const safeArea = useSafeArea();
  return (
    <CloseButton
      onPress={onPress}
      style={{
        position: 'absolute',
        top: safeArea.top + 10,
        right: safeArea.right + 16,
      }}
    />
  );
};
